import { render } from "./MenuSystem.vue?vue&type=template&id=4ca27375"
import script from "./MenuSystem.vue?vue&type=script&lang=js"
export * from "./MenuSystem.vue?vue&type=script&lang=js"

import "./MenuSystem.vue?vue&type=style&index=0&id=4ca27375&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__